import styles from './FJHeader.module.less';
import FJLocalStore from '@src/store/FJLocalStore';
import React from 'react';

interface Props {
    avatarUrl: string;
    email: string;
    icon: React.ReactNode;
    platform: string;
    defaultAvatar: React.ReactNode;
}

const FJHeader = ({ avatarUrl, email, icon, platform, defaultAvatar }: Props) => {
    return (
        <div className={styles.accountItem}>
            <div className={styles.avatar_box}>
                {avatarUrl ? <img src={avatarUrl} alt='Avatar' className={styles.avatar} /> : defaultAvatar}
                <div className={styles.platformInfo}>{icon}</div>
            </div>

            <div className={styles.userInfo}>
                <div>{FJLocalStore._(platform)}</div>
                <div className={styles.email}>{email}</div>
            </div>
        </div>
    );
};

export default FJHeader;
